import {styled, Box, IconButton} from "external/material"
import { SyncIcon } from 'external/material'
import useStudent from 'hooks/student'

const StyledSidebarRefreshData = styled(Box)(sidebarRefreshDataStyles)

export default function DashboardRefreshData(props) {

    const {update} = useStudent()

    return (
          <StyledSidebarRefreshData>
            <IconButton color="primary" onClick={() => {update({refreshData: {$apply: i => i + 1}})}} >
              <SyncIcon />
            </IconButton>
          </StyledSidebarRefreshData>
    )
}

function sidebarRefreshDataStyles() {
    return {
        marginLeft: 8,
        "& .MuiButtonBase-root": {
            padding:0
        }
    }
}

